<script setup lang="ts">
import ModalWrapper from '@/components/modals/ModalWrapper.vue'
import UiPanel from '@/components/shared/UiPanel.vue'
import UiButton from '@/components/shared/UiButton.vue'
import { useUiState } from '@/stores/uiState'

const uiState = useUiState()

const closeModal = () => {
  uiState.modals.attention.close()
}
</script>

<template>
  <teleport to="body">
    <modal-wrapper v-if="uiState.modals.attention.isOpen" class="z-[89]">
      <ui-panel class="attention__panel" :title="$t(uiState.modals.attention.titleKey)">
        <div class="attention__text text-center">
          {{ $t(uiState.modals.attention.descriptionKey) }}
        </div>
        <ui-button class="w-full" type="button" @click="closeModal">
          {{ $t(uiState.modals.attention.buttonKey) }}
        </ui-button>
      </ui-panel>
    </modal-wrapper>
  </teleport>
</template>